import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Dialog } from '@openng/optimus-ui/dialog';
import { ScrollPanel } from '@openng/optimus-ui/scrollpanel';
import { ButtonDirective } from '@openng/optimus-ui/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy-consent-container',
  templateUrl: './privacy-consent-container.component.html',
  styleUrls: ['./privacy-consent-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Dialog, ScrollPanel, ButtonDirective, TranslatePipe],
})
export class PrivacyConsentContainerComponent {
  @Input() displayDialog = false;

  readonly policyAcceptedEvent = output();

  policyAccepted(): void {
    this.displayDialog = false;
    this.policyAcceptedEvent.emit();
  }
}
